import React, { useMemo, useState } from "react";
import { Table, Spin, TimePicker, Checkbox } from "antd";
import PropTypes from "prop-types";
import { useFormContext } from "react-hook-form";
import { format } from "date-fns";
import dayjs from "dayjs";
import InTimePicker from "MainPages/Attendance/timelog/InTimePicker";
import ShiftController from "MainPages/Attendance/timelog/ShiftController";
import EditController from "./EditController";
import ProjectController from "./ProjectController";
import Input from "Components/UI/Input";
import SplitController from "./SplitController";
import SupplierInput from "./SupplierInput";
import TimeLogOptions from "Components/Modal/time-log-options";
import { Check, Edit } from "react-feather";
import { render } from "@fullcalendar/core/preact";
import { all_routes } from "Router/all_routes";
import { Link } from "react-router-dom";
import { formatDate } from "core/Operations/dateFormat";
import DeleteController from "./DeleteController";
import Description from "./Description";
import { weeklyOffValidationSchema } from "core/Operations/ValidationSchema/attendanceValidationSchema";
import { useTimeLogWeelyOffMutation } from "AppQuries/attendance/time-log";
import { TRUE } from "sass";
// import { createStyles } from "antd-style";

// const useStyle = createStyles(({ css, token }) => {
//   const { antCls } = token;
//   return {
//     customTable: css`
//       ${antCls}-table {
//         ${antCls}-table-container {
//           ${antCls}-table-body,
//           ${antCls}-table-content {
//             scrollbar-width: thin;
//             scrollbar-color: #eaeaea transparent;
//             scrollbar-gutter: stable;
//           }
//         }
//       }
//     `,
//   };
// });

const isApprovedOptions = [
  { label: "Approved", value: true },
  { label: "UnApproved", value: false },
];

const TimelogTable = ({
  isLoading,
  isSingleEmployee,
  attendanceData,
  handleUpdateAttendance,
  addAttendanceHandler,
  splitAttendanceDelete,
  setTotalWorkingHours,
  shiftOptions,
  shifts,
  projectsOptions,
  setSelectedEmployee,
  selectedEmployee,
  editHandler,
  permissions,
  description,
  markWeeklyOffHandler,
}) => {
  const { watch, setValue, register, getValues } = useFormContext();
  const [showTimeLogOptions, setShowTimeLogOptions] = useState(false);
  const [popupFor, setPopupFor] = useState(null);
  const [employee, setEmployee] = useState("");

  const { mutate: timeLogWeeklyOff } = useTimeLogWeelyOffMutation();
  const handleClose = () => {
    setShowTimeLogOptions(false);
    setEmployee("");
    setPopupFor(null);
  };

  const handleShow = (id, employeeName) => {
    setShowTimeLogOptions(true);
    setPopupFor(id);
    setEmployee(employeeName);
  };

  const handleTimeChange = ({ id, value, type }) => {
    if (type === "inTime") {
      if (watch(`attendance[${id}].shiftName`) === "")
        setValue(
          `attendance[${id}].shiftId`,
          watch(`attendance[${id}].defaultShift`).toString() || "",
        );
    }

    if (type === "outTime") {
      setValue(`attendance[${id}].hasOutTime`, true);
    }
    setValue(`attendance[${id}].${type}`, value, {
      shouldDirty: true,
      shouldValidate: false,
    });

    // setValue(`attendance[${id}].isAlternateDayOff`, false, {
    //   shouldDirty: true,
    // });

    // calculateTotalWorkingHours(id);
    handleUpdateAttendance(id);
  };

  const onApproveHandler = (id, e) => {
    setValue(`attendance[${id}].isApproved`, e);
    if (e === true) {
      setValue(`attendance[${id}].isReviewed`, e);
    }
    setValue(`attendance[${id}].approvedBy`, watch("userName"));
    setValue(
      `attendance[${id}].approvedDate`,
      format(new Date(), "yyyy-MM-dd"),
    );
    // setValue(`attendance[${record.id}].isApproved`, e.label);
    // handleUpdateAttendance(record.id);
    handleUpdateAttendance(id);
  };

  const columns = useMemo(
    () => [
      ...(!isSingleEmployee
        ? [
            {
              title: "Emp Code",
              dataIndex: "uniqueID",
            },
            {
              title: "Name",
              dataIndex: "employeeName",
              fixed: "left",
              width: "200px",
              className: "nowrap",
              render: (text, record) => (
                <Link
                  to={`${all_routes.employee}${all_routes.employee_view}/${record.employeeCode}`}
                  // className={`nowrap ${
                  //   record.remarks !== "" ? "timelog-colored-row" : ""
                  // }`}
                  className={`nowrap`}
                  target="_blank"
                >
                  {text}
                </Link>
              ),
            },
          ]
        : []),
      {
        title: "Date",
        dataIndex: "attendanceDate",
        fixed: "left",
        render: (text, record) => (
          <>
            <div style={{ width: "75px" }}>
              {format(new Date(text), "dd-MM-yyyy")}
            </div>
          </>
        ),
      },
      {
        title: "Day",
        dataIndex: "attendanceDay",
        render: (text, record) => (
          <>
            <div>{format(new Date(record.attendanceDate), "EEE")}</div>
          </>
        ),
      },
      {
        title: "In",
        dataIndex: "inTime",
        render: (text, record) => (
          <InTimePicker
            record={record}
            handleTimeChange={handleTimeChange}
            name="inTime"
            isApproved={record.isApproved}
            isReviewed={record.isReviewed}
            isFullPaidLeave={record.isFullPaidLeave}
            inTimeValue={record.inTime}
            isAlternateDayOff={record.isAlternateDayOff}
          />
        ),
      },
      {
        title: "Out",
        dataIndex: "outTime",
        render: (text, record) => (
          <InTimePicker
            record={record}
            handleTimeChange={handleTimeChange}
            name="outTime"
            isApproved={record.isApproved}
            isReviewed={record.isReviewed}
            isFullPaidLeave={record.isFullPaidLeave}
            inTimeValue={record.inTime}
            isAlternateDayOff={record.isAlternateDayOff}
          />
        ),
      },
      {
        title: "NH",
        dataIndex: "normalWorkingHours",
        render: (text, record) => Number(text).toFixed(2),
        // render: (text, record) => (
        //   <input
        //     {...register(`attendance[${record.id}].normalWorkingHours`)}
        //     name={`attendance[${record.id}].normalWorkingHours`}
        //     type="text"
        //     className={`form-control form-control-time-width`}
        //     value={watch(`attendance[${record.id}].normalWorkingHours`) || ""}
        //     readOnly={true}
        //   />
        // ),
      },
      {
        title: "OT1",
        dataIndex: "oT1",
        // render: (text, record) => (
        //   <input
        //     {...register(`attendance[${record.id}].oT1`)}
        //     name={`attendance[${record.id}].oT1`}
        //     type="text"
        //     className={`form-control form-control-time-width`}
        //     value={watch(`attendance[${record.id}].oT1`) || ""}
        //     readOnly={true}
        //   />
        // ),
      },
      {
        title: "OT2",
        dataIndex: "oT2",
        // render: (text, record) => (
        //   <input
        //     {...register(`attendance[${record.id}].oT2`)}
        //     name={`attendance[${record.id}].oT2`}
        //     type="text"
        //     className={`form-control form-control-time-width`}
        //     value={watch(`attendance[${record.id}].oT2`) || ""}
        //     readOnly={true}
        //   />
        // ),
      },
      {
        title: "TH",
        dataIndex: "totalWorkingHours",
        render: (text, record) => Number(text).toFixed(2),
        // render: (text, record) => (
        //   <input
        //     {...register(`attendance[${record.id}].totalWorkingHours`)}
        //     name={`attendance[${record.id}].totalWorkingHours`}
        //     type="text"
        //     className={`form-control form-control-time-width`}
        //     value={watch(`attendance[${record.id}].totalWorkingHours`) || ""}
        //     readOnly={true}
        //   />
        // ),
      },
      {
        title: "Remarks",
        dataIndex: "remarks",
        // render: (text, record) => (
        //   <input
        //     {...register(`attendance[${record.id}].remarks`)}
        //     name={`attendance[${record.id}].remarks`}
        //     type="text"
        //     className={`form-control`}
        //     value={watch(`attendance[${record.id}].remarks`) || ""}
        //     style={{ width: "100px" }}
        //     onBlur={() => handleUpdateAttendance(record.id)}
        //     readOnly
        //   />
        // ),
      },
      {
        title: "Action",
        render: (text, record) => (
          <div className="d-flex justify-content-center">
            {/* {(watch(`attendance[${record.id}].inTime`) === "00:00:00" ||
              watch(`attendance[${record.id}].inTime`) === "00:00") &&
            (watch(`attendance[${record.id}].outTime`) === "00:00:00" ||
              watch(`attendance[${record.id}].outTime`) === "00:00") ? (
              <Check className="me-2" />
            ) : ( */}
            <button
              type="button"
              className="btn btn-sm"
              onClick={() => handleShow(record.id, record.employeeName)}
              disabled={
                watch(`attendance[${record.id}].isApproved`) ||
                watch(`attendance[${record.id}].isReviewed`) ||
                watch(`attendance[${record.id}].isFullPaidLeave`)
              }
            >
              <Edit />
            </button>
            {/* )} */}
            <DeleteController
              isDisabled={record.isApproved || record.isFullPaidLeave}
              handleUpdateAttendance={handleUpdateAttendance}
              addAttendanceHandler={addAttendanceHandler}
              splitAttendanceDelete={splitAttendanceDelete}
              id={record.id}
              permissions={permissions}
            />
          </div>
        ),
      },
      {
        title: "Shift",
        dataIndex: "shiftName",
        render: (text, record) => (
          <ShiftController
            handleUpdateAttendance={handleUpdateAttendance}
            setTotalWorkingHours={setTotalWorkingHours}
            shifts={shifts}
            shiftOptions={shiftOptions}
            id={record.id}
            isDisabled={
              watch(`attendance[${record.id}].isApproved`) ||
              watch(`attendance[${record.id}].isReviewed`) ||
              watch(`attendance[${record.id}].isFullPaidLeave`)
            }
          />
        ),
        width: "160px",
      },
      {
        title: "Project",
        dataIndex: "projectName",
        render: (text, record) => (
          <ProjectController
            handleUpdateAttendance={handleUpdateAttendance}
            id={record.id}
            projectsOptions={projectsOptions}
          />
        ),
        width: "160px",
      },
      {
        title: "Status",
        dataIndex: "isApproved",
        render: (text, record) => (
          <Input
            name={`attendance[${record.id}].isApproved`}
            type="commonSelect"
            className={`form-control select-option-height`}
            value={watch(`attendance[${record.id}].isApproved`)}
            optionData={isApprovedOptions}
            onSelect={(e) => onApproveHandler(record.id, e)}
            style={{ width: "150px" }}
            disabled={watch(`attendance[${record.id}].isApproved`)}
          />
        ),
        width: "160px",
      },
      // {
      //   title: "Approved By",
      //   dataIndex: "approvedBy",
      //   width: "100px",
      // },
      // {
      //   title: "Approved Date",
      //   dataIndex: "approvedDate",
      //   width: "100px",
      //   render: (text, record) => format(new Date(text), "dd-MM-yyyy"),
      // },
      {
        title: "EC(2x)",
        dataIndex: "extraCharge",
        // render: (text, record) => (
        //   <input
        //     {...register(`attendance[${record.id}].extraCharge`)}
        //     name={`attendance[${record.id}].extraCharge`}
        //     type="text"
        //     className={`form-control`}
        //     value={watch(`attendance[${record.id}].extraCharge`) || ""}
        //     readOnly={true}
        //     style={{ width: "100px" }}
        //   />
        // ),
      },
      {
        title: "Late",
        dataIndex: "late",
        // render: (text, record) => (
        //   <input
        //     name={`attendance[${record.id}].late`}
        //     type="text"
        //     className={`form-control`}
        //     defaultValue={watch(`attendance[${record.id}].late`)}
        //     readOnly={true}
        //     style={{ width: "100px" }}
        //   />
        // ),
      },
      {
        title: "DW",
        dataIndex: "dayworking",
      },
      {
        title: "WT",
        dataIndex: "waitingTime",
        render: (text, record) => (
          <InTimePicker
            record={record}
            handleTimeChange={handleTimeChange}
            name="waitingTime"
            isApproved={record.isApproved}
            isReviewed={record.isReviewed}
            isFullPaidLeave={record.isFullPaidLeave}
            inTimeValue={record.inTime}
            isAlternateDayOff={record.isAlternateDayOff}
          />
        ),
      },
      {
        title: "WTROT",
        dataIndex: "wtrot",
        render: (text, record) => (
          <InTimePicker
            record={record}
            handleTimeChange={handleTimeChange}
            name="wtrot"
            isApproved={record.isApproved}
            isReviewed={record.isReviewed}
            isFullPaidLeave={record.isFullPaidLeave}
            inTimeValue={record.inTime}
            isAlternateDayOff={record.isAlternateDayOff}
          />
        ),
      },

      // {
      //   title: "Supplier Company",
      //   dataIndex: "supplierCompany",
      //   render: (text, record) => (
      //     <SupplierInput
      //       id={record.id}
      //       onSubmit={handleUpdateAttendance}
      //       disabled={
      //         watch(`attendance[${record.id}].isApproved`) ||
      //         watch(`attendance[${record.id}].isReviewed`)
      //       }
      //     />
      //   ),
      //   width: "100px",
      // },
      // {
      //   title: "service",
      //   dataIndex: "service",
      //   // width: "200px",
      //   render: (text, record) => (
      //     <input
      //       {...register(`attendance[${record.id}].service`)}
      //       name={`attendance[${record.id}].service`}
      //       type="text"
      //       className={`form-control`}
      //       defaultValue={watch(`attendance[${record.id}].service`)}
      //       readOnly={true}
      //       style={{ width: "200px", height: "30px", fontSize: "12px" }}
      //     />
      //   ),
      //   width: "210px",
      // },
      {
        title: "Split",
        render: (text, record) => (
          <SplitController
            addAttendanceHandler={addAttendanceHandler}
            id={record.id}
            isDisabled={
              record.isApproved ||
              record.isFullPaidLeave ||
              record.isReviewed ||
              !record.hasOutTime ||
              record.isAlternateDayOff
            }
          />
        ),
      },
      {
        title: "Edit",
        render: (text, record) => (
          <EditController
            id={record.id}
            isDisabled={!record.isReviewed}
            editHandler={editHandler}
            permissions={permissions}
          />
        ),
      },
    ],
    [watch("attendance")],
  );

  const handleSelect = (record, selected) => {
    let newSelection = selected
      ? [...selectedEmployee, record.id]
      : selectedEmployee.filter((code) => code !== record.id);

    // setValue("selectedEmployee", newSelection);
    setSelectedEmployee(newSelection);
  };

  const toggleSelectAll = () => {
    setSelectedEmployee((prev) => {
      return prev.length === attendanceData?.length
        ? []
        : attendanceData?.map((r) => r.id);
    });
  };

  const headerCheckbox = (
    <Checkbox
      checked={selectedEmployee?.length === attendanceData?.length}
      indeterminate={
        selectedEmployee?.length > 0 &&
        selectedEmployee?.length < attendanceData?.length
      }
      onChange={toggleSelectAll}
    />
  );

  const rowSelection = {
    selectedRowKeys: selectedEmployee,
    type: "checkbox",
    fixed: true,
    onSelect: handleSelect,
    columnTitle: headerCheckbox,
  };

  const weeklyOffHandler = async (
    id,
    isHalfDay,
    inTime,
    outTime,
    shift = null,
  ) => {
    const updatedRow = attendanceData.find((item) => item.id === id);

    const haveSplit = attendanceData.filter((item) => item.id === id)[0]
      ?.haveSplit;

    if (haveSplit) {
      splitAttendanceDelete(id);
    }

    setValue(
      `attendance[${id}]`,
      {
        ...getValues(`attendance[${id}]`),
        attendanceValue: 0,
        inTime: inTime || "00:00:00",
        outTime: outTime || "00:00:00",
        normalWorkingHours: "0",
        oT1: 0,
        oT2: 0,
        totalWorkingHours: 0,
        scheduleId: updatedRow?.scheduleId || 0,
        shiftName: "",
        projectCode: "0",
        projectName: "",
        mode: "MM",
        waitingTime: "00:00:00",
        isApproved: false,
        remarks: "Rest Day",
        // extra fields
        dayworking: 1,
        extraCharge: 0,
        late: "00:00",
        wtnhEdit: true,
        supplierCompany: "",
        service: "",
        isReviewed: false,
        reviewDate: "",
        reviewBy: "",
        approvedDate: "",
        approvedBy: "",
        haveSplit: false,
        breakTime: 0,
        salaryType: null,
        wtrot: "00:00:00",
        isPaidLeave: 0,
        hasOutTime: true,
        defaultShift: 2,
        isHoliday: true,
        isFullPaidLeave: false,
        // shiftId: updatedRow?.shiftId || "",
        haveShift: true,
        normalHours: 0,
        isAlternateDayOff: true,
        isHalfDay: Boolean(isHalfDay),
        // haveShift: shift !== null ? true : false,
        shiftId: shift !== null ? shift?.toString() : updatedRow?.shiftId || "",
      },
      { shouldDirty: true },
    );

    const payload = watch(`attendance[${id}]`);

    try {
      await weeklyOffValidationSchema.validate(payload, { abortEarly: false });
    } catch (validationError) {
      console.error("Validation errors:", validationError.inner);
      return;
    }

    markWeeklyOffHandler(payload, id);
    handleClose();
  };

  const updateTimelog = async (
    timelogOption,
    isHalfDay,
    id,
    inTime = "00:00:00",
    outTime = "00:00:00",
    shift = null,
  ) => {
    if (timelogOption === "WeeklyOff") {
      await weeklyOffHandler(id, isHalfDay, inTime, outTime, shift);
    } else {
      const haveAbsent = timelogOption === "Absent" ? true : false;
      const haveHalfDay = isHalfDay ? true : false;

      const attendanceValue =
        haveAbsent && haveHalfDay
          ? 0.5
          : timelogOption === "Absent"
            ? 0
            : isHalfDay
              ? 0.5
              : 1.0;

      const mode = timelogOption === "Punch" ? "AA" : "MM";

      if (attendanceValue === 0.5) {
        setValue(`attendance[${id}].isHalfDay`, true);
        setValue(`attendance[${id}].inTime`, inTime);
        setValue(`attendance[${id}].outTime`, outTime);
        setValue(`attendance[${id}].hasOutTime`, true);
      } else if (attendanceValue === 0) {
        setValue(`attendance[${id}].inTime`, "00:00:00");
        setValue(`attendance[${id}].outTime`, "00:00:00");
        setValue(`attendance[${id}].haveShift`, false);
        setValue(`attendance[${id}].scheduleId`, 0);
        setValue(`attendance[${id}].shiftId`, "");
        setValue(`attendance[${id}].shiftName`, "");
      }
      setValue(`attendance[${id}].mode`, mode, { shouldDirty: true });
      setValue(`attendance[${id}].attendanceValue`, attendanceValue, {
        shouldDirty: true,
      });
      setValue(`attendance[${id}].remarks`, timelogOption, {
        shouldDirty: true,
      });
      await handleUpdateAttendance(id);
    }

    handleClose();
  };

  // const { styles } = useStyle();

  return (
    <>
      <div className="card border-0">
        <div className="card-body">
          <div className="table-responsive timelog-table">
            <Spin spinning={isLoading}>
              <Table
                // className={styles.customTable}
                rowSelection={rowSelection}
                dataSource={attendanceData}
                columns={columns}
                pagination={false}
                rowKey={(record) => record.id}
                size="middle"
                scroll={{
                  x: 2400,
                  y: 500, // Enables sticky header
                }}
                bordered
                rowClassName={(record) => {
                  return record.isHoliday ? "timelog-colored-row" : "";
                }}
              />
            </Spin>
          </div>
          <Description description={description} />
        </div>
      </div>
      <TimeLogOptions
        employeeName={employee}
        id={popupFor}
        onSubmit={updateTimelog}
        show={showTimeLogOptions}
        handleClose={handleClose}
        shiftOptions={shiftOptions}
      />
    </>
  );
};

export default React.memo(TimelogTable);

TimelogTable.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  isSingleEmployee: PropTypes.bool.isRequired,
  attendanceData: PropTypes.array.isRequired,
  handleUpdateAttendance: PropTypes.func.isRequired,
  addAttendanceHandler: PropTypes.func.isRequired,
  splitAttendanceDelete: PropTypes.func.isRequired,
  setTotalWorkingHours: PropTypes.func.isRequired,
  setSelectedEmployee: PropTypes.func.isRequired,
  selectedEmployee: PropTypes.array.isRequired,
  shiftOptions: PropTypes.array.isRequired,
  shifts: PropTypes.array.isRequired,
  projectsOptions: PropTypes.array.isRequired,
  editHandler: PropTypes.func.isRequired,
  permissions: PropTypes.array.isRequired,
  description: PropTypes.array.isRequired,
  markWeeklyOffHandler: PropTypes.func.isRequired,
};
